import { IconButton, makeStyles } from '@material-ui/core';
import { MdClose } from 'react-icons/md';

const useStyles = makeStyles((theme: any) => ({
    modalContainer: {
        position: 'fixed',
        zIndex: 50,
        left: 0,
        top: 0,
        width: '100% !important',
        height: '100% !important',
        backgroundColor: 'rgba(0,0,0,0.6)',
        hidden: 'true',
        overflowY: 'scroll',
        maxWidth: "100% !important"
    },
    modalContent:{
        display: 'block',
        margin: 'auto',
        zIndex: 100,
        
        background: '#F3F3F9',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        border: 'none',
        padding: 25,
        marginTop: 35,
         marginBottom: 35,

        width: 'fit-content',
        minWidth: '75%',
        maxWidth: '90%',
    },
    title: {
        fontSize: 20,
        fontWeight: 700,
    }, 
    topRow: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 10
    },
    content:{
        width: '100%',
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        padding: 30
    },
}));

interface Props {
    hidden: boolean;
    setHidden: React.Dispatch<React.SetStateAction<boolean>>;
    title: string;
    width ?: string;
}

export const Modal: React.FC<Props> = ({hidden,setHidden,title,width,children}) => {
    const classes = useStyles();

    return ( 
        <div className={classes.modalContainer} hidden={hidden}>
            <div className={classes.modalContent} style={{width: width ? width : 'fit-content'}}>
                <div className={classes.topRow}>
                    <div className={classes.title}>{title}</div>
                    <IconButton onClick={() => {setHidden(true)}}>
                        <MdClose />
                    </IconButton>
                </div>
                <div className={classes.content}>
                    {children}
                </div>
            </div>
        </div>
    );
}